/**
 * Standard API response format
 */
export interface ApiResponse<T> {
  retorno: T | null;
  sucesso: boolean;
  mensagens: string[];
}

